/* eslint-disable max-classes-per-file */
import { Tags } from 'opentracing';
import { parseLinkHeader } from './utils/parse-link-header';
export class BaseError extends Error {
    constructor(...params) {
        super(...params);
        // required to keep prototype chain when targeting ES5 see
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
export const assertStatusCodes = (acceptedStatusCodes) => ({ response, logger, span, method, }) => {
    const { status, statusText, url } = response;
    if (acceptedStatusCodes.includes(status)) {
        return;
    }
    if (span) {
        span.setTag('error.code', status);
        span.log({ event: 'error', statusText });
        span.setTag(Tags.ERROR, true);
        span.finish();
    }
    logger.error(`Unexpected status code for ${method} on ${url}, Got `, status);
    throw new Error(`Failed with status code: ${status}`);
};
const LINK_HEADER_REL = 'rel="auth"';
export class AuthenticationError extends BaseError {
    constructor(statusCode, linkHeader, ...rest) {
        super(...rest);
        this.statusCode = statusCode;
        if (!linkHeader) {
            return;
        }
        const links = parseLinkHeader(linkHeader.indexOf(LINK_HEADER_REL) === -1
            ? `${linkHeader};${LINK_HEADER_REL}`
            : linkHeader);
        if (!links) {
            return;
        }
        this.redirectTarget = links.auth.url;
    }
}
export const assertAuthentication = () => ({ response, span }) => {
    const { status, headers, statusText } = response;
    if (status !== 401 && status !== 403) {
        return;
    }
    if (span) {
        span.setTag('error.code', status);
        span.setTag(Tags.ERROR, true);
        span.finish();
    }
    throw new AuthenticationError(status, headers.get('Link'), statusText);
};
//# sourceMappingURL=validators.js.map